import { render, staticRenderFns } from "./EditWarning.vue?vue&type=template&id=759129e6&scoped=true&"
import script from "./EditWarning.vue?vue&type=script&lang=ts&"
export * from "./EditWarning.vue?vue&type=script&lang=ts&"
import style0 from "./EditWarning.vue?vue&type=style&index=0&id=759129e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759129e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VDialog})
